
const ROOT = '/task-management'

const taskManagementPaths = {
  root: ROOT,
  addRole: `${ROOT}/add-task`,
};

export default taskManagementPaths;
